

const React = require("react");
const { Route } = require('react-router-dom')

let Icons              = require("../Icons.jsx");
let Head               = require("./Head.jsx");
let Router             = require("./Router.jsx");
let ApplicationContext = require("../config/ApplicationContext.js");
let ErrorPage          = require("./generic/ErrorPage.jsx");

class App extends React.Component {

    componentDidMount() {
        window.wafCCPAForceShow = true;

        (function(a, b, c, d) {
            a = ApplicationContext.tealiumURL
            b = document;
            c = 'script';
            d = b.createElement(c);
            d.src = a;
            d.type = 'text/java' + c;
            d.async = true;
            a = b.getElementsByTagName(c)[0];
            a.parentNode.insertBefore(d, a);
        })();
    }

    render() {
        return (
            <html>
                <Head {...this.props}></Head>
                <body>
                    <Icons/>
                    <ErrorPage
                        {...this.props}
                        renderPage={addedProps =>
                            <Route
                                render={ props => <Router {...props} {...addedProps}  />}
                            />
                        }
                    />
                    <script src={ApplicationContext.assetUrlPrefix + "/dist/bundle.js"} async />
                </body>
            </html>
        );
    }
}


module.exports = App;
